import React from 'react';
import { Table, TableHeader, TableHeaderColumn, TableRow, TableBody } from 'material-ui';
import ListRow from './ListRow';
import R from 'ramda';
const SingleLocTemplates = ({
                              docs,
                              deleteTemplate,
                              archiveUnarchive,
                              updateTemplateProps,
                              deleteDraft,
                              updateDraftProps,
                              getContractsCount,
                              saveNewTemplateName,
                              updateProps,
                              showLocName,
                              router,
                              doNotShowActionButtons,
                            }) => {
  return (
    <div>
      <Table bodyStyle={{ overflow: 'visible' }} style={{ overflow: 'visible' }} wrapperStyle={{ overflow: 'visible' }}>
        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
          <TableRow>
            <TableHeaderColumn colSpan="20" style={{ height: '40px' }}>Template</TableHeaderColumn>
            <TableHeaderColumn colSpan="3" style={{ padding: 0, textAlign: 'center', height: '40px' }}>Partners</TableHeaderColumn>
            <TableHeaderColumn colSpan="3" style={{ padding: 0, textAlign: 'center', height: '40px' }}>Status</TableHeaderColumn>
            <TableHeaderColumn colSpan="3" style={{ padding: 0, textAlign: 'center', height: '40px' }}>Periods</TableHeaderColumn>
            <TableHeaderColumn colSpan="3" style={{ padding: 0, textAlign: 'center', height: '40px' }}>Modified</TableHeaderColumn>
            <TableHeaderColumn colSpan="4" style={{ padding: 0, textAlign: 'center', height: '40px', display: doNotShowActionButtons ? 'none' : '' }}>Actions</TableHeaderColumn>
          </TableRow>
        </TableHeader>
        <TableBody style={{ overflow: 'visible' }}>
          {
            docs.map((doc, i) => {
              const isTemplate = !doc.state;
              const basicUrl = `/contracting/${isTemplate ? 'template' : 'draft'}/${isTemplate ? doc._id : doc.originalContractId}/`;
              const updateDocProps = isTemplate ? (data) => updateTemplateProps(doc._id, data)
                : (data) => updateDraftProps(doc.originalContractId, data);
              const deleteDoc = isTemplate ? () => deleteTemplate(doc._id)
                : () => deleteDraft(doc.originFrom === 'edited', doc.originalContractId);
              const saveNewName = isTemplate ? (newName) => saveNewTemplateName('template', doc._id, newName)
                : (newName) => saveNewTemplateName('draft', doc.originalContractId, newName);
              return (
                <ListRow
                  key={`${doc.templateName}${doc.updatedAt}${doc.state}${i}`}
                  template={doc}
                  isTemplate={isTemplate}
                  showLocName={showLocName}
                  getContractsCount={getContractsCount}
                  deleteTemplate={deleteDoc}
                  archiveUnarchive={() => archiveUnarchive({ isArchived: !doc.isArchived, templateId: doc._id })}
                  updateTemplateProps={updateDocProps}
                  saveNewTemplateName={saveNewName}
                  updateProps={updateProps}
                  viewTemplate={doc.showEditNameConfirmButton ? () => {} : () => router.push(`${basicUrl}details`)}
                  viewPartners={() => router.push(`${basicUrl}partners`)}
                  doNotShowActionButtons={doNotShowActionButtons}
                />);
            })
          }
        </TableBody>
      </Table>
      {
        // docs.map((doc, i) => {
        //   return !doc.state ? (
        //     <TemplateRow
        //       key={`${doc.templateName}${doc.updatedAt}${i}`}
        //       style={{ borderBottom: i === docs.length - 1 ? 'none' : '1px solid rgba(0, 0, 0, 0.1)' }}
        //       template={doc}
        //       showLocName={showLocName}
        //       getContractsCount={getContractsCount}
        //       deleteTemplate={() => deleteTemplate(doc._id)}
        //       archiveUnarchive={() => archiveUnarchive({ isArchived: !doc.isArchived, templateId: doc._id })}
        //       updateTemplateProps={(data) => updateTemplateProps(doc._id, data)}
        //       saveNewTemplateName={saveNewTemplateName('template')}
        //       updateProps={updateProps}
        //       viewTemplate={() => router.push(`/contracting/template/${doc._id}/details`)}
        //       viewPartners={() => router.push(`/contracting/template/${doc._id}/partners`)}
        //     />) : (
        //     <DraftRow
        //       key={`${doc.templateName}${doc.updatedAt}${doc.state}${i}`}
        //       showLocName={showLocName}
        //       style={{ borderBottom: i === docs.length - 1 ? 'none' : '1px solid rgba(0, 0, 0, 0.1)' }}
        //       draft={doc}
        //       deleteDraft={}
        //       updateDraftProps={}
        //     />);
        // })
      }
    </div>
  );
};
export default SingleLocTemplates;



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/list/single-loc.jsx